import { createReducer } from 'redux-create-reducer'
import * as actionTypes from '../constants/chatActionTypes'

const initialState = []

export default createReducer(initialState, {
	[actionTypes.NEW_MESSAGE](state, action) {
		const text = action.payload.text || action.payload.post || "";
		if (action.payload.customId === 'VISITOR_CHAT_HISTORY' || text.startsWith('VISITOR_CHAT_HISTORY')) {
			return state
		}
		const foundEvent = state.filter(event => {
			return (
				(event.customId && event.customId === action.payload.customId) || (event.id && event.id === action.payload.id)
			)
		})
		if (!foundEvent.length) {
			return [...state, action.payload]
		}
		return state
	},
	[actionTypes.SEND_MESSAGE](state, action) {
		const text = action.payload.text || action.payload.post;
		if (action.payload.customId === 'VISITOR_CHAT_HISTORY' || text.startsWith('VISITOR_CHAT_HISTORY')) {
			return state
		}
		return [
			...state,
			{
				...action.payload,
				status: 'SENDING',
				own: true,
			},
		]
	},
	[actionTypes.CHAT_STARTED]() {
		return []
	}
})
export const getEvents = state => state.events



// WEBPACK FOOTER //
// ./src/reducers/events.js